import React from 'react';
import PropTypes from 'prop-types';
import './AudioClipLabel.css';

const AudioClipLabel = ({ audioName }) => {
  const cleanName = audioName.replaceAll(/ ?\(copy\) ?/gi, '').trim();
  
  return (
    <div className="audio-clip-label">
      <svg className="audio-clip-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 8h16M4 16h16" />
      </svg>
      <span className="audio-clip-name">{cleanName}</span>
    </div>
  );
};

AudioClipLabel.propTypes = {
  audioName: PropTypes.string.isRequired,
};

export default AudioClipLabel;
